import doc              from '@widesk-core/decorators/doc';
import model            from '@widesk-core/decorators/model';
import ShopServiceModel from '@/models/ShopServiceModel';

@model.cacheDuration()
@model.urnResource('related_content_status')
@doc.path('/related_content_statuses/{?id}')
export default class RelatedContentStatusModel extends ShopServiceModel {
	private declare _tsFilters: {
		'reference': Shop_RelatedContentStatusReference;
	};

	private declare _tsSorts: {
		'id': string;
	};

	@doc.string declare label: string;
	@doc.string declare reference: Shop_RelatedContentStatusReference;

	public get color() {
		switch (this.reference) {
			case 'disabled':
				return 'red';
			case 'enabled':
				return 'green';
		}
	}
}
